export default __webpack_public_path__ + "static/media/Pharmacon of Avoidance.23d54abe.jpg";